


















import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'NavigationDrawerUser',

  computed: {
    ...mapGetters('user', [
      'getUser',
    ]),
  },
});
